import React from 'react';
import './Disposablecont.css';
import fittingImage from '../../../imgs/Disposablecont.webp'; 

const Disposablecont = () => {
  return (
    <div className="Disposablecont-container"data-aos="fade-down">
        <h2>APPLICATIONS</h2>
        
      <img src={fittingImage} alt="Fitting Corrosion" className="Disposablecont-image" />
    </div>
  );
};

export default Disposablecont;
